import { DATE_RANGE_CRATE, SORT_CRATE } from 'constants/crate';
import { CRATE_TYPES } from 'constants/types';

export const TypeOptions = [
    { label: 'Track', value: CRATE_TYPES.TRACK },
    { label: 'Release', value: CRATE_TYPES.RELEASE },
    { label: 'Playlist', value: CRATE_TYPES.PLAYLIST },
];

export const SoftOptions = [
    { label: 'Newest', value: SORT_CRATE.CREATED_AT_DESC },
    { label: 'Oldest', value: SORT_CRATE.CREATED_AT_ASC },
    // { label: "Most bought", value: SORT_CRATE.BOUGHT_BY_DESC },
];

export const Date_rangerOptions = [
    { label: 'all', value: DATE_RANGE_CRATE.ALL_TIME },
    { label: '7 days', value: DATE_RANGE_CRATE.LAST_7_DAYS },
    { label: '30 days', value: DATE_RANGE_CRATE.LAST_30_DAYS },
    { label: '90 days', value: DATE_RANGE_CRATE.LAST_90_DAYS },
];
